class ConfiguratorManualFeModalDeleteProductController {
    constructor($http, $window, close, product_letter_id) {
        'ngInject';

        this.$http = $http;
        this.productLetterId = product_letter_id;
        this.closeCallback = close;
    }

    save() {
        this.closeCallback(true, 200);
    }

    close() {
        this.closeCallback(false, 200);
    }
}

export default ConfiguratorManualFeModalDeleteProductController;